import {createSlice} from '@reduxjs/toolkit'

import {RootState} from '~/stores'

export enum LOGIN_STATUS {
  LOGIN = 1,
  NOT_LOGIN = 0,
}

type DeviceInfo = {
  h_app: 'wanxiang' | 'dokimo'
  h_did: string
  h_m?: number
  token: string
  h_ts: number
  h_ch: string
  h_model: string
  h_dt?: number
  h_av?: string
  h_wanxiang?: string
  // 客户端版本码，用于新功能灰度判定
  h_av_code?: number
  // 其他必须
  ua: string
  statusBar: number
  isLogin?: LOGIN_STATUS
  isreg: number
  theme: 'light' | 'dark' | ''
}

const initialState: DeviceInfo = {
  h_app: 'wanxiang',
  h_ts: Date.now(),
  h_ch: '',
  h_did: '',
  h_model: '',
  token: '',
  h_wanxiang: '',
  ua: '',
  statusBar: 0,
  isreg: null,
  theme: 'light',
}

export const deviceInfoSlice = createSlice({
  name: 'deviceInfo',
  initialState,
  reducers: {
    set(state, action) {
      return {
        ...state,
        ...action.payload,
      }
    },
  },
})

export const getDefaultVersionFromUrl = () => {
  try {
    const urlParams = new URLSearchParams(window.location.search)
    const deviceinfo = urlParams.get('deviceinfo')
    if (!deviceinfo) {
      return ''
    }
    const deviceinfoJson = JSON.parse(deviceinfo) || {}
    return deviceinfoJson.h_av || ''
  } catch {
    return ''
  }
}

export const selectDeviceInfo = (state: RootState) => state.deviceInfo
// 用户登录状态
export const selectIsLogin = (state: RootState) => state.deviceInfo?.isLogin

export default deviceInfoSlice.reducer
